EventedPromise = require 'utils/evented-promise'
require '../transforms/array-of-objects'

###
# Модель чернового блюда
###
App.DraftDish = DS.Model.extend
  menu_order    : DS.attr 'number'
  can_zoom      : DS.attr 'boolean'
  description   : DS.attr 'string'
  ingredients   : DS.attr 'string'
  is_hidden     : DS.attr 'boolean'
  is_list       : DS.attr 'boolean'
  is_next_day   : DS.attr 'boolean'
  next_day_hour_count : DS.attr 'number'
  is_bonus_only : DS.attr 'boolean'
  no_bonus_accrue : DS.attr 'boolean'
  restrict_bonus_withdrawal : DS.attr 'boolean'
  dont_discount : DS.attr 'boolean'
  timetabled    : DS.attr 'boolean'
  name          : DS.attr 'string'
  options       : DS.attr 'arrayOfObjects'
  photo         : DS.attr 'mixed'
  price         : DS.attr 'string'
  weight        : DS.attr 'number'
  weight_unit   : DS.attr 'string'
  external_id   : DS.attr 'string'
  availability  : DS.attr 'arrayOfObjects'
  has_modifier_scheme: DS.attr 'boolean'
  disabled_sources   : DS.attr 'string'
  metric             : DS.attr 'boolean'
  price_weight_unit  : DS.attr 'string'
  min_qty            : DS.attr 'number'
  delta_qty          : DS.attr 'number'
  excise_unit        : DS.attr 'string'
  ingredients        : DS.attr 'string'
  calories           : DS.attr 'number'
  proteins           : DS.attr 'number'
  fats               : DS.attr 'number'
  carbs              : DS.attr 'number'
  all_media          : DS.attr 'mixed'
  alt_media          : DS.attr 'mixed'

  suggest_priority : DS.attr 'number'

  cooking_time  : DS.attr 'number'
  cooking_line  : DS.belongsTo 'cooking_line', async: true

  old_price     : DS.attr 'string'
  tags          : DS.attr 'string'

  prohibit_takeaway : DS.attr 'boolean'
  prohibit_delivery : DS.attr 'boolean'
  is_popular        : DS.attr 'boolean'

  required          : DS.attr 'boolean'

  meta_title         : DS.attr 'string'
  meta_description   : DS.attr 'string'

  params: DS.attr 'mixed'

  # Внешние связи
  draft_category: DS.belongsTo 'draft_category', async: true
  organization:   DS.belongsTo 'organization', async: true
  modifier_scheme: DS.belongsTo 'modifier_scheme', async: true

  restaurant_prices  : DS.hasMany 'restaurant_price', async: false

  restaurantsSortOrder: ['restaurant.city','restaurant.name']
  sortedRestaurantPrices: Em.computed.sort('restaurant_prices', 'restaurantsSortOrder')

  env:   Em.inject.service('environment')

  disabled_sources_array: ((key, value, oldValue)->
    if arguments.length == 1
      return [] unless @get('disabled_sources')
      return @get('disabled_sources').split(',')
    else
      @set 'disabled_sources', value.join(',')
      return value
  ).property('disabled_sources')


  # Для карточки с блюдом
  cardBackgroundStyle: (->
    photo = @get('photo.medium_square')
    result = if photo then "background-image:  url(#{photo});" else ''
    result.htmlSafe()
  ).property('photo.medium_square')

  weightUnitName: (->
    return '' unless @get('weight_unit')
    Em.I18n.t("draft_dish.weight_units_short." + @get('weight_unit'))
  ).property('weight_unit')

  weightUnitFullName: (->
    return '' unless @get('weight_unit')
    Em.I18n.t("draft_dish.weight_units." + @get('weight_unit'))
  ).property('weight_unit')

  priceWeightUnitFullName:(->
    return '' unless @get('price_weight_unit')
    Em.I18n.t("draft_dish.weight_units." + @get('price_weight_unit'))
  ).property('price_weight_unit')

  exciseUnitFullName: (->
    return '' unless @get('excise_unit')
    Em.I18n.t("draft_dish.excise_units.#{@get('excise_unit')}")
  ).property('excise_unit')

  uploadPhoto: (file, settings) ->
    promise = @fileUpload('photo', file, settings || {})
    promise.then => @notifyRecordChange()
    promise

  reorder: (target_id) ->
    @nonRESTAction('PUT', 'reorder', { target_id })
    .then => @notifyRecordChange()

  ####
  # Нормализация параметров конфигуратора
  ####
  normalizeConfigurator: ->
    options = @get('options')
    return unless Em.isArray(options)

    # Удаляем «плохие» конфигурации — c пустыми items
    badConfigurations = options.reject (o) =>
      o.get('items.length') > 0

    options.removeObjects(badConfigurations)

    # Нормализуем числовые параметры
    options.forEach (o) =>
      o.set('min', Number(o.get('min')) ? 0)
      o.set('max', Number(o.get('max')) ? 0)

      items = o.get('items')
      if Em.isArray(items)
        items.forEach (item) =>
          price = Number(Em.get(item, 'price')) ? 0.0
          Em.set(item, 'price', price)

    # Пустой конфигуратор сериализуется как null
    @set('options', null) if Em.isEmpty(options)
